// extracted by mini-css-extract-plugin
export var askAiIcon = "_nx-j";
export var category = "_nx-9";
export var categoryHeader = "_nx-e";
export var container = "_nx-0";
export var group = "_nx-a";
export var groupItems = "_nx-f";
export var groupSeparator = "_nx-k";
export var loading = "_nx-1";
export var noResults = "_nx-3";
export var placeholder = "_nx-2";
export var resultContent = "_nx-5";
export var resultIcon = "_nx-c";
export var resultItem = "_nx-g";
export var resultMeta = "_nx-8";
export var resultSubtitle = "_nx-7";
export var resultSuffix = "_nx-i";
export var resultTitle = "_nx-6";
export var resultsList = "_nx-4";
export var searchGroup = "_nx-d";
export var selected = "_nx-h";
export var subgroup = "_nx-b";